module.exports = __webpack_public_path__ + "static/media/Base feature icon-5.f1ce919b.svg";